import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';

import request from './images/request.jpg';
import agp from './images/agp.jpg';
import day from './images/day.jpg';
import statistic from './images/statistic.jpg';

function HelpForPractitioner() {
  return (
    <main id="forPractitioner" className="textPage">
      <h1>Ohjeet - Sensotrend Dashboard</h1>
      <ul className="toc">
        <li><Link to="/help">Etusivulle</Link></li>
        <br />         
        <li><Link to="/helpIntro">Palvelun esittely</Link></li> 
        <li><Link to="/helpGuidance">Käyttöohjeet</Link></li>
        <li><Link to="/helpTips">Tiedon hyödyntäminen</Link></li>
        <br /> 
        <li><big><b>Ammattilaisille</b></big></li>
      </ul>
      <h1>Ammattilaisille</h1>
      <p>Lukuaika noin 4 min.</p>
      <ul>
        <li><Link to="#startup">Sensotrend Dashboardin käynnistäminen</Link></li>
        <li><Link to="#dataAccess">Lupapyyntö potilaalle</Link></li>
        <li><Link to="#dataUsage">Tietojen hyödyntäminen potilastyössä</Link></li>
        <li><Link to="#toPatientSystem">Tietojen tallentaminen potilaskertomukseen</Link></li>
      </ul>
      <section id="startup">
        <h2>Sensotrend Dashboardin käynnistäminen</h2>
        <p>
          <Link to="#top">Takaisin alkuun</Link>
        </p>
        <p>
          Sensotrend Dashboard voidaan käynnistetään suoraan potilastietojärjestelmästä käsin.
        </p>
      </section>
      <section id="dataAccess">
        <h2>Lupapyyntö potilaalle</h2>
        <p>
          <Link to="#top">Takaisin alkuun</Link>
        </p>
        <p>
          Ensimmäinen askel Sensotrend Dashboardin näyttämien tietojen hyödyntämisessä
          potilastyössä on tietojen katselupyynnön lähettäminen potilaalle. Kutsuun tarvittava
          linkki luodaan potilastietojärjestelmän kautta ja se voidaan lähettää potilaalle joko
          sähköpostitse tai muun hänen käyttämänsä viestintäkanavan välityksellä.
        </p>
        <p>
          Lupapyyntö voi olla vapaamuotoinen. Tärkeää lupapyynnössä on se, että lupapyyntöä
          varten muodostettu linkki on juuri se, jonka Sensotrendin palvelu on muodostanut. Alla on
          esimerkki potilaalle lähetettävästä tietojenkatselupyynnöstä.
        </p>
        <p>
          <img src={request} alt="Tietojenkatselupyyntö potilaalle" />
        </p>
      </section>
      <section id="dataUsage">
        <h2>Tietojen hyödyntäminen potilastyössä</h2>
        <p>
          <Link to="#top">Takaisin alkuun</Link>
        </p>
        <p>
          Sensotrend Dashboard tuottamia tietoja voidaan hyödyntää potilastyössä monin eri tavoin.
          Perinteisin tapa on tarkastella hoitotasapainoa yhdelle sivulle kootun <a
          href="http://www.agpreport.org/agp/about">AGP-raportin</a> avulla. Tähän näkymään on
          koottu potilaan käytössä olevien insuliinipumpun, glukoosisensorien ja
          verensokerimittarien tuottama tieto kahden viikon ajalta yhdellä silmäyksellä
          tarkasteltavaksi.
        </p>
        <p>
          <img src={agp} alt="AGP-näkymä" />
        </p>
        <p>
          Tätä edistyneempi tapa on tarkastella Sensotrend Dashboardin päivänäkymän avulla
          glukoositasapainoon vaikuttavia tekijöitä. Tälle näkymälle olemme koonneet potilaan
          käyttämistä lääkinnällisestä laitteista tietoa, jota on rikastettu
          hyvinvointisovelluksista ja muista lähteistä tulevalla tiedolla. Näkymän avulla pystytään
          esimerkiksi tarkastelemaan ravinnon ja liikunnan vaikutusta potilaan glukoositasoihin.
        </p>
        <p>
          Tavoitteemme on saada diabeetikko oppimaan hänen hoitotasapainoonsa vaikuttavien
          tekijöiden vaikutuksesta ja pääsemään oppimisen kautta entistä parempiin hoitotuloksiin.
        </p>
        <p>
          <img src={day} alt="Päivänäkymä" />
        </p>
      </section>
      <section id="toPatientSystem">
        <h2>Tietojen tallentaminen potilaskertomukseen</h2>
        <p>
          <Link to="#top">Takaisin alkuun</Link>
        </p>
        <p>
          Sensotrend Dashboard sisältää tietojen potilaskertomukseen tallentamista helpottavia
          toimintoja. AGP-näkymän oikeassa yläkulmassa on "Aika glukoosialueilla" -kaavio. Kun
          hiiren kursorin vie tämän kaavion päälle, tulee näkyviin hoitotasapainoa kuvaavat
          tunnusluvut sisältävä ponnahdusikkuna. Hiiren vasen painiketta painettaessa tunnusluvun
          kopioituvat leikepöydälle, mistä ne on helppo liittää potilaskertomukseen.
        </p>
        <p>
          <img src={statistic} alt="Tunnusluvut" />
        </p>
      </section>
      <footer>
        {/* The date is for MDR, annex I, clause 23.4, subclause y).
            Date format is specified in ISO 1041:2008 & A1:2013, clause 4.4.
        */}
        <small>2021-06-11</small>
      </footer>
    </main>
  );
}

export default HelpForPractitioner;